// @owlcat/app-shell — the fleet's shared app chrome.
//
// Usage in an app header (a thin server wrapper resolves i18n + URLs, then):
//   import { SiteHeader } from "@owlcat/app-shell";
//   import { Link } from "@/lib/i18n/navigation";
//   <SiteHeader
//     linkComponent={Link}
//     brand={{ label: APP_NAME, href: "/" }}
//     profile={{ accountsUrl, profileUrl, appsUrl, returnTo, labels }}
//   />
export { SiteHeader } from "./SiteHeader";
// The fleet app sidebar (desktop rail + mobile drawer) — same look/behavior
// across apps. App supplies items/brand/footer + its own linkComponent.
export { AppSidebar } from "./AppSidebar";
// The shared sidebar footer chrome (subscription slot + profile + support + legal).
export { AppSidebarFooter } from "./AppSidebarFooter";
// The fleet's shared legal footer — ONE canonical set of legal links (Terms,
// Privacy, Cookie settings, Imprint, Contact) mounted in every app's root layout.
export { LegalFooter } from "./LegalFooter";
// Fleet-wide shared support entry — a floating contact form that POSTs to the ONE
// canonical accounts /support endpoint (replaces the Tawk.to live chat). Any chrome
// can open it without its own trigger via openSupportWidget().
export { SupportWidget, openSupportWidget, SUPPORT_OPEN_EVENT } from "./SupportWidget";
// Shared header controls — the ONE cluster ([Language] [Theme] [Profile]) every
// app uses so the header is identical fleet-wide. Also exported individually for
// non-SiteHeader chrome (e.g. portal's sidebar, shop's nav).
export { AppHeaderControls } from "./AppHeaderControls";
export { ThemeToggle } from "./ThemeToggle";
export { LanguageSwitcher } from "./LanguageSwitcher";
// Fleet-wide cookie consent — ONE shared banner + a parent-domain consent cookie
// every sibling app reads. See consent.ts for the legal single-controller model.
export { CookieConsent, useConsent } from "./CookieConsent";
export { CONSENT_COOKIE, CONSENT_VERSION, CONSENT_MAX_AGE, CONSENT_CHANGE_EVENT, CONSENT_OPEN_EVENT, readConsent, writeConsent, hasConsent, hasStoredConsent, onConsentChange, openConsentBanner, buildConsentCookie, parseConsent, toRecord, } from "./consent";
// In-app purchase widgets — buy a subscription (<SubscribeWidget>) or top up wallet
// tokens (<BuyTokensWidget>) WITHOUT the redirect-to-accounts bounce. Context-gated:
// Telegram Mini App → Stars only (card path never rendered — Telegram ToS); browser →
// Stripe EMBEDDED Checkout in an in-app modal + Stars. Open from anywhere via
// openSubscribe() / openBuyTokens() (event-driven, like openSupportWidget).
export { SubscribeWidget, BuyTokensWidget, openSubscribe, openBuyTokens, isSubscribeWidgetMounted, isBuyTokensWidgetMounted, SUBSCRIBE_OPEN_EVENT, BUY_TOKENS_OPEN_EVENT, PURCHASE_COMPLETE_EVENT, } from "./SubscribeWidget";
export { isTelegramMiniApp, openTelegramInvoice } from "./telegram";
export { paymentMethods, pickDisplayCurrency, currencyForLocale, formatPrice, entitlementHasTier, balanceIncreased, packShareOfMonth, planCtaState, } from "./purchase-logic";
// Fleet-wide PostHog product analytics — consent-gated on the `analytics`
// category. Also available at the "@owlcat/app-shell/analytics" subpath; the
// main-entry re-export lets apps import it alongside the rest of the chrome.
export { AnalyticsProvider, useAnalytics, useTrack } from "./analytics";
export { FLEET_EVENT_NAMES } from "./analytics-events";
export { SubscriptionPill } from "./SubscriptionPill";
